import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import { useEffect } from 'react'

import { addInterceptor, removeInterceptor } from '../utils'

export const useInterceptor = (
  axiosInstance: AxiosInstance,
  interceptor: (config: AxiosRequestConfig) => AxiosRequestConfig,
) => {
  useEffect(() => {
    const id = addInterceptor(axiosInstance, interceptor)
    return () => {
      removeInterceptor(axiosInstance, id)
    }
  }, [axiosInstance, interceptor])
}
